import { DriverCredentials } from '../../domain/credentials/DriverCredentials';
import { DriverCredentialsDTO } from '../../domain/credentials/DriverCredentialsDTO';
import { DriversSubscriptionCredentials } from '../../domain/credentials/DriversSubscriptionCredentials';

export class DriverCredentialsMapper {
  static toDomain(props: DriverCredentialsDTO): DriverCredentials {
    const { id, meta, project_id, organization_id, permissions, subscription } = props;

    return DriverCredentials.create({
      id,
      meta,
      project_id: project_id,
      organization_id: organization_id,
      permissions: permissions,
      subscription: DriversSubscriptionCredentials.create({
        active: subscription.active,
        items: subscription.items,
      }),
    });
  }
}
